import { Link } from 'react-router';
import styled from '@emotion/styled';

export const StyledLink = styled(Link)`
  margin-top: 25px;
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: text-decoration-color 0.3s ease;

  :hover {
    text-decoration-color: inherit;
  }
`;
